import DocumentImage from "../utils/services/documentImageService";
import crudTemplate from "../templates/crudTemplate.js";
import { createSuccessMessage } from "../utils/service";

let crud = crudTemplate(DocumentImage);
const state = {
  ...crud.state
};
const getters = {
  ...crud.getters
};

const actions = {
  ...crud.actions,
  getList(state, { params = {}, onSuccess = () => {} }) {
    crud.actions.getList(state, { params, onSuccess }).then(() => {
      state.state.list.forEach(item =>
        state.dispatch("getImage", {
          item,
          onSuccess: url => {
            state.commit("setImage", { item, url });
          }
        })
      );
    });
  },
  getImage(_, { item, onSuccess = () => {}, onError = () => {} }) {
    return DocumentImage.getImage(item.url, onSuccess, onError);
  },
  update(
    _,
    { item, errorHandler = () => {}, onSuccess = () => {}, onError = () => {} }
  ) {
    let onSuccessCallback = res => {
      createSuccessMessage("update");
      onSuccess(res);
    };
    return crud.actions.update(_, {
      item,
      errorHandler,
      onSuccess: i => {
        if (item.image) {
          DocumentImage.upload(
            { ...item, ...i },
            onSuccessCallback,
            onError,
            errorHandler
          );
        } else {
          onSuccessCallback();
        }
      }
    });
  },
  create(
    _,
    { item, errorHandler = () => {}, onSuccess = () => {}, onError = () => {} }
  ) {
    let onSuccessCallback = res => {
      createSuccessMessage("create");
      onSuccess(res);
    };
    return crud.actions.create(_, {
      item,
      errorHandler,
      onSuccess: i => {
        DocumentImage.upload(
          { ...item, ...i },
          onSuccessCallback,
          onError,
          errorHandler
        );
      }
    });
  }
};

const mutations = {
  ...crud.mutations,
  setList(state, { list, page }) {
    state.list = list.map(i => ({ ...i, image: "" }));
    state.page = page;
  },
  setImage(state, { item, url }) {
    let index = state.list.findIndex(i => i.id === item.id);
    if (index >= 0) {
      state.list[index].image = url;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
